// 26 ADM-003 (ruling H30): an admin session ends after 30 minutes with no
// activity, and lasts 12 hours at most however busy it is. Sensitive actions
// need a fresh second-factor check within 10 minutes. Pure: time is passed in.

export interface SessionLimits {
  /** admin.session_timeout_min */
  idleMinutes: number;
  /** admin.session_max_hours */
  maxHours: number;
  /** admin.stepup_minutes */
  stepUpMinutes: number;
}

export const DEFAULT_LIMITS: SessionLimits = { idleMinutes: 30, maxHours: 12, stepUpMinutes: 10 };

export interface SessionTimes {
  startedAt: number;
  lastActivityAt: number;
  lastSecondFactorAt: number;
}

export type SessionState =
  { kind: 'active'; endsAt: number } | { kind: 'ended'; reason: 'idle' | 'max_age' };

const MIN = 60_000;

export function sessionState(
  t: SessionTimes,
  now: number,
  l: SessionLimits = DEFAULT_LIMITS,
): SessionState {
  const maxEnd = t.startedAt + l.maxHours * 60 * MIN;
  const idleEnd = t.lastActivityAt + l.idleMinutes * MIN;
  if (now >= maxEnd) return { kind: 'ended', reason: 'max_age' };
  if (now >= idleEnd) return { kind: 'ended', reason: 'idle' };
  return { kind: 'active', endsAt: Math.min(maxEnd, idleEnd) };
}

export function needsStepUp(
  t: SessionTimes,
  now: number,
  l: SessionLimits = DEFAULT_LIMITS,
): boolean {
  return now - t.lastSecondFactorAt > l.stepUpMinutes * MIN;
}
